import _default from './Pagination';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/Pagination/index.js
// module id = 600
// module chunks = 0